import request from "@/utils/http"
import { cacheRequest } from "@/utils/decorator"

export function createRole(role, appId) {
  return request.post(`/users/createRole`, role, { params: { appId } }).commonDeal()
}

export function updateRole(role) {
  return request.post(`/users/updateRole`, role).commonDeal()
}

export function deleteRole(roleId) {
  return request.post(`/users/deleteRole`, null, { params: { roleId } })
}

export function getRoles({ appId, cache = true } = {}) {
  return roleApi.getRoles(appId, cache)
}

export function getRolesWithNum(appId) {
  return request.get("/users/roles/withNum", { params: { appId } }).commonDeal()
}

export function getExtraPriLevelList(sheetId) {
  return request.get("/sheet/getExtraPriLevelList", { params: { sheetId } }).commonDeal()
}

export function addExtraPriLevel({ sheetId, name, filters }) {
  return request.post("/sheet/addExtraPriLevel", { sheetId, name, filters }).commonDeal()
}

export function updateExtraPriLevel({ id, sheetId, name, filters }) {
  return request.post("/sheet/updateExtraPriLevel", { id, sheetId, name, filters }).commonDeal()
}

export function deleteExtraPriLevel(id) {
  return request.post("/sheet/deleteExtraPriLevel", null, { params: { id } }).commonDeal()
}

class RoleApi {
  @cacheRequest()
  getRoles(appId, cache) {
    return request.get("/users/roles", { params: { appId } }).commonDeal()
  }
}
const roleApi = new RoleApi()
